import { useQuery, UseQueryResult } from 'react-query';
import { ProductRetrieve } from 'types';
import { client } from 'utils/api-client';

export default function useProduct(
  productId: string | undefined,
): UseQueryResult<{ data: ProductRetrieve }> {
  const fetchProduct = (): Promise<{ data: ProductRetrieve }> => {
    return client.get(`products/${productId}/`);
  };

  return useQuery(['products', productId], fetchProduct, {
    enabled: !!productId,
  });
}
